// extracted by mini-css-extract-plugin
export default {"addApps":"control_addApps__nv4Ok","control":"control_control__feXpg","small":"control_small__IKCMk","tiny":"control_tiny__jMA75"};